import React from 'react';
import styles from './Toggle.module.css';

const Toggle = ({ checked, indeterminate, onChange, label, disabled }) => (
  <button
    type="button"
    className={`${styles.toggle} ${checked ? styles.on : ''} ${
      indeterminate ? styles.mixed : ''
    }`}
    onClick={() => onChange(!checked, indeterminate)}
    disabled={disabled}
  >
    <span className={styles.knob}>
      {indeterminate && <span className={styles.dash} />}
    </span>
    {label && <span className={styles.label}>{label}</span>}
  </button>
);

export default Toggle;
